import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import type {
	IContext,
	PineJS,
	StudyMetaInfo,
} from "@/charting_library/charting_library";
import { filterDataByMainSeries } from "@/components/widgets/Chart/helpers/filterDataByMainSeries/filterDataByMainSeries";
import { TIMEFRAME_MAP } from "@/components/widgets/Chart/services/PriceService/PriceService";
import type { Timeframes } from "@/components/widgets/Chart/types";
import { RevisionService } from "@/components/widgets/Revision/lib/services/RevisionService";
import type { RevisionExt } from "@/components/widgets/Revision/types";
import {
	CustomIndicatorService,
	getDefaultParams,
} from "../CustomIndicatorService";

export abstract class RevisionsIndicatorService extends CustomIndicatorService<RevisionExt> {
	abstract fieldMapper(item: RevisionExt): PriceInfo<UTCTimestamp>;
	abstract get requiredFields(): string[];
	abstract getPlotsData(PineJS: PineJS, context: IContext): number[];
	abstract get styles(): StudyMetaInfo["styles"];

	async getBarData(
		from: number,
		to: number,
		interval: Timeframes,
		ticker: string,
	): Promise<PriceInfo<UTCTimestamp>[]> {
		if (TIMEFRAME_MAP[interval].isIntraday) {
			return [];
		}
		const response = await RevisionService.create().getPriceData(
			{
				...getDefaultParams(from, to, ticker),
				fields: ["date", ...this.requiredFields],
			},
			this.fieldMapper,
		);
		const filteredResponse = await filterDataByMainSeries(
			response.data ?? [],
			from,
			to,
			ticker,
			interval,
		);

		return filteredResponse;
	}

	get plots(): StudyMetaInfo["plots"] {
		return [
			{
				id: "plot_0",
				type: "line",
			},
		] as StudyMetaInfo["plots"];
	}
}
